@if (profileField$ | async; as profileField) {
    @if ((typedValues$ | async)?.length === 0) {
        <ng-container *ngTemplateOutlet="emptyData; context: { profileField: profileField }"></ng-container>
    }
    @for (typedValue of typedValues$ | async; track typedValue) {
        @if (typedValue.value?.length !== 0 && typeFieldDefinitions.get(typedValue.type)) {
            <dt class="sh-description-list__term" [id]="profileField.FieldDefinition.DottedKey + '.' + typedValue.type" style="{{ nestedPadding$ | async }}">
                <sh-field-label
                    [label]="profileField.DisplayLabel + ' (' + (typeTranslations.get(typedValue.type) || typedValue.type) + ')'"
                    [labelIcons]="$labelIcons()"
                ></sh-field-label>
            </dt>
            @if (typeFieldDefinitions.get(typedValue.type); as typeFieldDef) {
                <dd class="sh-description-list__details">
                    <ng-container
                        *ngTemplateOutlet="
                            canSearchOnClick(typeFieldDef) ? searchableData : nonSearchableData;
                            context: { values: typedValue.value, fieldDefinition: typeFieldDef }
                        "
                    >
                    </ng-container>
                </dd>
            }
        }
    }
}

<ng-template #searchableData let-values="values" let-fieldDefinition="fieldDefinition">
    @for (value of values; track value; let index = $index) {
        <span>
            <a class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)">{{ value }}</a>
            @if (index < values.length - 1) {
                ,
            }
        </span>
    }
</ng-template>

<ng-template #nonSearchableData let-values="values">
    @for (value of values; track value; let index = $index) {
        <span
            >{{ value }}
            @if (index < values.length - 1) {
                ,
            }
        </span>
    }
</ng-template>

<ng-template #emptyData let-profileField="profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        {{ profileField.DisplayLabel }}
    </dt>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
